import { Badge, Button } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { trackFinancesComingSoonInterested } from 'src/Services/Mixpanel/events';

import styles from './ComingSoonTile.module.scss';
import { Props } from './ComingSoonTile.types';

const ComingSoonTile = ({ icon, title, description, featureKey }: Props) => {
  const { t } = useTranslation();
  const [interested, setInterested] = useState(false);

  const handleInterested = () => {
    if (interested) return;
    setInterested(true);
    trackFinancesComingSoonInterested({ feature: featureKey });
  };

  return (
    <div className={styles.tile}>
      <div className={styles.titleRow}>
        <span className={styles.iconWrap}>{icon}</span>
        <h3 className={styles.title}>{title}</h3>
        <Badge variant="light" color="yellow" size="sm">
          {t('comingSoon.badge', 'Bientôt')}
        </Badge>
        <div className={styles.action}>
          {interested ? (
            <span className={styles.thanks}>
              {t('comingSoon.thanks', 'Merci ! On vous tient au courant.')}
            </span>
          ) : (
            <Button variant="outline" size="sm" onClick={handleInterested}>
              {t('comingSoon.interested', "Ça m'intéresse")}
            </Button>
          )}
        </div>
      </div>
      <p className={styles.description}>{description}</p>
    </div>
  );
};

export default ComingSoonTile;
